<template>
  <div class="support-button" data-cy="support-button">
    <span class="support-text">
      {{ t('supportRequest.openButton.textBeforeLink') }}
      <a data-cy="support-link" @click="openSupportRequest" class="support-link">{{
        t('supportRequest.openButton.linkText')
      }}</a>
    </span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      @click="handleClose"
    >
      <path
        d="M2.14565 3.35399C2.09917 3.3075 2.06229 3.25231 2.03713 3.19157C2.01197 3.13083 1.99902 3.06573 1.99902 2.99999C1.99902 2.93425 2.01197 2.86915 2.03713 2.80841C2.06229 2.74767 2.09917 2.69248 2.14565 2.64599C2.19214 2.5995 2.24733 2.56263 2.30807 2.53747C2.36881 2.51231 2.43391 2.49936 2.49966 2.49936C2.5654 2.49936 2.6305 2.51231 2.69124 2.53747C2.75198 2.56263 2.80717 2.5995 2.85366 2.64599L7.99965 7.79299L13.1457 2.64599C13.1921 2.5995 13.2473 2.56263 13.3081 2.53747C13.3688 2.51231 13.4339 2.49936 13.4997 2.49936C13.5654 2.49936 13.6305 2.51231 13.6912 2.53747C13.752 2.56263 13.8072 2.5995 13.8537 2.64599C13.9001 2.69248 13.937 2.74767 13.9622 2.80841C13.9873 2.86915 14.0003 2.93425 14.0003 2.99999C14.0003 3.06573 13.9873 3.13083 13.9622 3.19157C13.937 3.25231 13.9001 3.3075 13.8537 3.35399L8.70665 8.49999L13.8537 13.646C13.9001 13.6925 13.937 13.7477 13.9622 13.8084C13.9873 13.8691 14.0003 13.9342 14.0003 14C14.0003 14.0657 13.9873 14.1308 13.9622 14.1916C13.937 14.2523 13.9001 14.3075 13.8537 14.354C13.8072 14.4005 13.752 14.4374 13.6912 14.4625C13.6305 14.4877 13.5654 14.5006 13.4997 14.5006C13.4339 14.5006 13.3688 14.4877 13.3081 14.4625C13.2473 14.4374 13.1921 14.4005 13.1457 14.354L7.99965 9.20699L2.85366 14.354C2.80717 14.4005 2.75198 14.4374 2.69124 14.4625C2.6305 14.4877 2.5654 14.5006 2.49966 14.5006C2.43391 14.5006 2.36881 14.4877 2.30807 14.4625C2.24733 14.4374 2.19214 14.4005 2.14565 14.354C2.09917 14.3075 2.06229 14.2523 2.03713 14.1916C2.01197 14.1308 1.99902 14.0657 1.99902 14C1.99902 13.9342 2.01197 13.8691 2.03713 13.8084C2.06229 13.7477 2.09917 13.6925 2.14565 13.646L7.29265 8.49999L2.14565 3.35399Z"
        fill="#3B4352"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { t } from '../../composables/Translation'
import { useAppStore } from '../../stores/appStore'

import { State } from '../../types/app/state'

const appStore = useAppStore()

const emit = defineEmits<{
  (e: 'close'): void
}>()

function openSupportRequest() {
  appStore.setState(State.AttemptToOpenSR)
}

function handleClose() {
  emit('close')
  appStore.supportRequestButtonVisible = false
}
</script>

<style scoped lang="scss">
.support-button {
  border-radius: 12px;
  background: var(--text-background-color);

  display: flex;
  padding: 12px;
  justify-content: right;
  align-items: center;
  gap: 10px;

  padding: 12px 12px;
  justify-content: center;
  align-items: center;
  align-self: center;
}

svg {
  cursor: pointer;
  border-radius: 8px;
  padding: 6px;
  margin-right: -6px;
  transition:
    transform 120ms ease,
    background-color 120ms ease;

  &:hover {
    background-color: rgba(59, 67, 82, 0.06);
  }

  &:active {
    transform: scale(0.96);
  }

  &:focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
}

button {
  outline: none;
}

.support-text {
  color: var(--primary-color);
  font-size: 14px;
}

.support-link {
  font-weight: 700;
  text-decoration: none;
  color: var(--primary-color);
}

.support-link:hover {
  text-decoration: underline;
}
</style>
